<template>
  <div class="container py-5">
    <h2 class="mb-4">Minhas Notificações</h2>
    <ul class="list-group" v-if="notificacoes.length">
      <li
        v-for="n in notificacoes"
        :key="n.id"
        class="list-group-item d-flex justify-content-between align-items-start"
        :class="Number(n.lida) === 1 ? 'text-muted' : ''"
      >
        <div class="ms-2 me-auto">
          <div class="fw-bold">
            <i
              :class="Number(n.lida) === 1 ? 'bi bi-check-circle-fill text-success me-2' : 'bi bi-envelope-fill text-primary me-2'"
            ></i>
            {{ n.titulo }}
          </div>
          <p class="mb-1">
            {{ n.mensagem }}
            <template v-if="n.nome_candidato && n.id_candidato">
              <br />
              Candidato:
              <router-link :to="`/admin/usuario/${n.id_candidato}`">
                {{ n.nome_candidato }}
              </router-link>
            </template>
            <template v-if="n.titulo_vaga && n.vaga_id">
              <br />
              Vaga:
              <router-link :to="`/vaga/${n.vaga_id}`">
                {{ n.titulo_vaga }}
              </router-link>
            </template>
          </p>
          <small class="text-muted">{{ formatarData(n.data_criacao) }}</small>
        </div>
        <button
          v-if="Number(n.lida) !== 1"
          class="btn btn-sm btn-outline-primary"
          @click="marcarComoLida(n.id)"
        >
          Marcar como lida
        </button>
      </li>
    </ul>
    <p v-else class="text-muted">Nenhuma notificação por enquanto.</p>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'NotificacoesVie',
  data() {
    return {
      notificacoes: [],
    };
  },
  mounted() {
    const usuario = JSON.parse(localStorage.getItem('usuario'));
    api.get(`listar_notificacoes.php?usuario_id=${usuario.id}&is_admin=${usuario.tipo === 'admin' ? 1 : 0}`)
      .then(res => {
        console.log('Notificações recebidas:', res.data); // <-- Adicionado para debug
        this.notificacoes = res.data;
      })
      .catch(() => alert('Erro ao carregar notificações.'));
  },
  methods: {
  formatarData(data) {
  if (!data) return '—';
  const d = new Date(data);
  if (isNaN(d)) return '—';
  return d.toLocaleString('pt-BR');
},
    marcarComoLida(id) {
      api.post('marcar_notificacao_lida.php', { id })
        .then(() => {
          const n = this.notificacoes.find(n => n.id === id);
          if (n) n.lida = 1;
        })
        .catch(() => {
          alert('Erro ao marcar notificação como lida.');
        });
    }
  }
};
</script>
